import React, { useState, useContext } from "react";
import Input from "../UI/Input";
import AddressDetails from "./AddressDetails";
import AppContext from "../../store/app-context";

import styles from "./CustomerDetails.module.css";

const CustomerDetails = (props) => {
  const appCtx = useContext(AppContext);

  let label_customerCompany = "Customer Company";
  let label_customerFName = "Customer First Name";
  let label_customerLName = "Customer Last Name";
  let label_customerEmail = "Customer Email";
  let label_customerSoldTo = "Customer Sold-To Number";
  let label_customerShipTo = "Customer Ship-To Number";
  let label_noCustShipBill =
    "I do not have the customer bill-to or ship-to number";
  let label_companyRequired = "Company name is required.";
  let label_custFNameRequired = "First name is required.";
  let label_custLNameRequired = "Last name is required.";
  let label_custEmailRequired = "Email is required.";
  let label_custSoldToRequired = "Sold-To is required.";
  let label_custShipToRequired = "Ship-To is required.";

  if (appCtx && appCtx.bioradResources) {
    label_customerCompany = appCtx.bioradResources.Customer_Company
      ? appCtx.bioradResources.Customer_Company
      : "Customer Company";
    label_customerFName = appCtx.bioradResources.Customer_FName
      ? appCtx.bioradResources.Customer_FName
      : "Customer First Name";
    label_customerLName = appCtx.bioradResources.Customer_LName
      ? appCtx.bioradResources.Customer_LName
      : "Customer Last Name";
    label_customerEmail = appCtx.bioradResources.Customer_Email
      ? appCtx.bioradResources.Customer_Email
      : "Customer Email";
    label_customerSoldTo = appCtx.bioradResources.Customer_SoldTo
      ? appCtx.bioradResources.Customer_SoldTo
      : "Customer Sold-To Number";
    label_customerShipTo = appCtx.bioradResources.Customer_ShipTo
      ? appCtx.bioradResources.Customer_ShipTo
      : "Customer Ship-To Number";
    label_noCustShipBill = appCtx.bioradResources.Do_Not_Have_SoldTo_ShipTo
      ? appCtx.bioradResources.Do_Not_Have_SoldTo_ShipTo
      : "I do not have the customer bill-to or ship-to number";
    label_companyRequired = appCtx.bioradResources.Customer_Company_Required
      ? appCtx.bioradResources.Customer_Company_Required
      : "Company name is required.";
    label_custFNameRequired = appCtx.bioradResources
      .Customer_First_Name_Required
      ? appCtx.bioradResources.Customer_First_Name_Required
      : "First name is required.";
    label_custLNameRequired = appCtx.bioradResources.Customer_Last_Name_Required
      ? appCtx.bioradResources.Customer_Last_Name_Required
      : "Last name is required.";
    label_custEmailRequired = appCtx.bioradResources.Customer_Email_Required
      ? appCtx.bioradResources.Customer_Email_Required
      : "Email is required.";
    label_custSoldToRequired = appCtx.bioradResources.Customer_SoldTo_Required
      ? appCtx.bioradResources.Customer_SoldTo_Required
      : "Sold-To is required.";
    label_custShipToRequired = appCtx.bioradResources.Customer_ShipTo_Required
      ? appCtx.bioradResources.Customer_ShipTo_Required
      : "Ship-To is required.";
  }

  const [showAddressForm, setShowAddressForm] = useState(false);

  const onAddCheckChange = (event) => {
    setShowAddressForm(event.target.checked);
  };

  const [company, setCompany] = useState("");
  const [companyTouched, setCompanyTouched] = useState(false);

  const companyInputIsValid = company.trim() !== "";
  const companyInputIsInvalid = companyTouched
    ? !companyInputIsValid
    : props.invalidFieldList && props.invalidFieldList.company;

  const companyInputChangeHandler = (event) => {
    setCompany(event.target.value);
    setCompanyTouched(true);
  };

  const companyInputBlurHandler = (event) => {
    setCompanyTouched(true);
  };

  const [custFName, setCustFName] = useState("");
  const [custFNameTouched, setCustFNameTouched] = useState(false);

  const custFNameInputIsValid = custFName.trim() !== "";
  const custFNameInputIsInvalid = custFNameTouched
    ? !custFNameInputIsValid
    : props.invalidFieldList && props.invalidFieldList.custFName;

  const custFNameInputChangeHandler = (event) => {
    setCustFName(event.target.value);
    setCustFNameTouched(true);
  };

  const custFNameInputBlurHandler = (event) => {
    setCustFNameTouched(true);
  };

  const [custLName, setCustLName] = useState("");
  const [custLNameTouched, setCustLNameTouched] = useState(false);

  const custLNameInputIsValid = custLName.trim() !== "";
  const custLNameInputIsInvalid = custLNameTouched
    ? !custLNameInputIsValid
    : props.invalidFieldList && props.invalidFieldList.custLName;

  const custLNameInputChangeHandler = (event) => {
    setCustLName(event.target.value);
    setCustLNameTouched(true);
  };

  const custLNameInputBlurHandler = (event) => {
    setCustLNameTouched(true);
  };

  const [custEmail, setCustEmail] = useState("");
  const [custEmailTouched, setCustEmailTouched] = useState(false);

  const custEmailInputIsValid = custEmail.trim() !== "";
  const custEmailInputIsInvalid = custEmailTouched
    ? !custEmailInputIsValid
    : props.invalidFieldList && props.invalidFieldList.custEmail;

  const custEmailInputChangeHandler = (event) => {
    setCustEmail(event.target.value);
    setCustEmailTouched(true);
  };

  const custEmailInputBlurHandler = (event) => {
    setCustEmailTouched(true);
  };

  const [custSoldTo, setCustSoldTo] = useState("");
  const [custSoldToTouched, setCustSoldToTouched] = useState(false);

  const custSoldToInputIsValid = showAddressForm || custSoldTo.trim() !== "";
  const custSoldToInputIsInvalid = custSoldToTouched
    ? !custSoldToInputIsValid
    : props.invalidFieldList && props.invalidFieldList.custSoldTo;

  const custSoldToInputChangeHandler = (event) => {
    setCustSoldTo(event.target.value);
    setCustSoldToTouched(true);
  };

  const custSoldToInputBlurHandler = (event) => {
    setCustSoldToTouched(true);
  };

  const [custShipTo, setCustShipTo] = useState("");
  const [custShipToTouched, setCustShipToTouched] = useState(false);

  const custShipToInputIsValid = showAddressForm || custShipTo.trim() !== "";
  const custShipToInputIsInvalid = custShipToTouched
    ? !custShipToInputIsValid
    : props.invalidFieldList && props.invalidFieldList.custShipTo;

  const custShipToInputChangeHandler = (event) => {
    setCustShipTo(event.target.value);
    setCustShipToTouched(true);
  };

  const custShipToInputBlurHandler = (event) => {
    setCustShipToTouched(true);
  };

  return (
    <div className={styles.custForm}>
      <div className={styles.custName}>
        <Input
          label={label_customerCompany}
          input={{
            id: "company",
            name: "company",
            onChange: companyInputChangeHandler,
            onBlur: companyInputBlurHandler,
            value: company,
            maxlength: "90",
          }}
        />
        {companyInputIsInvalid && (
          <p className={styles.errormsg}>{label_companyRequired}</p>
        )}
      </div>
      <div className={styles.custName}>
        <Input
          label={label_customerFName}
          input={{
            id: "custFName",
            name: "custFName",
            onChange: custFNameInputChangeHandler,
            onBlur: custFNameInputBlurHandler,
            value: custFName,
            maxlength: "90",
          }}
        />
        {custFNameInputIsInvalid && (
          <p className={styles.errormsg}>{label_custFNameRequired}</p>
        )}
      </div>
      <div className={styles.custName}>
        <Input
          label={label_customerLName}
          input={{
            id: "custLName",
            name: "custLName",
            onChange: custLNameInputChangeHandler,
            onBlur: custLNameInputBlurHandler,
            value: custLName,
            maxlength: "90",
          }}
        />
        {custLNameInputIsInvalid && (
          <p className={styles.errormsg}>{label_custLNameRequired}</p>
        )}
      </div>
      <div className={styles.custEmail}>
        <Input
          label={label_customerEmail}
          input={{
            id: "custEmail",
            name: "custEmail",
            onChange: custEmailInputChangeHandler,
            onBlur: custEmailInputBlurHandler,
            value: custEmail,
            maxlength: "120",
          }}
        />
        {custEmailInputIsInvalid && (
          <p className={styles.errormsg}>{label_custEmailRequired}</p>
        )}
      </div>
      {!showAddressForm && (
        <div className={styles.custAcct}>
          <Input
            label={label_customerSoldTo}
            input={{
              id: "custSoldTo",
              name: "custSoldTo",
              onChange: custSoldToInputChangeHandler,
              onBlur: custSoldToInputBlurHandler,
              value: custSoldTo,
              maxlength: 7,
              placeholder:
                "Please enter customer Sold-To - can be maximum of 7 digits.",
            }}
          />
          {custSoldToInputIsInvalid && (
            <p className={styles.errormsg}>{label_custSoldToRequired}</p>
          )}
        </div>
      )}
      {!showAddressForm && (
        <div className={styles.custAcct}>
          <Input
            label={label_customerShipTo}
            input={{
              id: "custShipTo",
              name: "custShipTo",
              onChange: custShipToInputChangeHandler,
              onBlur: custShipToInputBlurHandler,
              value: custShipTo,
              maxLength: 7,
              placeholder:
                "Please enter customer Ship-To - can be maximum of 7 digits.",
            }}
          />
          {custShipToInputIsInvalid && (
            <p className={styles.errormsg}>{label_custShipToRequired}</p>
          )}
        </div>
      )}
      <div className={styles.noAcct}>
        <Input
          label={label_noCustShipBill}
          input={{
            id: "addCheck",
            name: "addCheck",
            type: "checkbox",
            onChange: onAddCheckChange,
          }}
        />
      </div>
      {showAddressForm && (
        <AddressDetails invalidFieldList={props.invalidFieldList} />
      )}
    </div>
  );
};

export default CustomerDetails;
